import { memo, useContext } from 'react';
import { getParticipantInitials, getParticipantNotAvailableName } from '../../../utils/mediaParticipantListUtils';
import { getSpeakerTimeline } from '../../../utils/mediaSpeakerTimelineUtils';
import Timeline from './Timeline';
import { MediaPlaybackControlsContext } from '../../context/MediaPlaybackControlsContext';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MediaSpeakerTimeline = props => {
  const {
    transcriptUtterances,
    speakers
  } = props;
  const {
    preciseDuration
  } = useContext(MediaPlaybackControlsContext);
  if (!transcriptUtterances || !speakers.length) {
    return null;
  }
  const speakerTimelineObjects = getSpeakerTimeline(speakers, preciseDuration);
  const SpeakerNameInitials = speakerObject => {
    const speakerName = speakerObject.speaker.name ? speakerObject.speaker.name : getParticipantNotAvailableName(speakerObject.speaker);
    const speakerInitials = getParticipantInitials(speakerName);
    return speakerInitials ? /*#__PURE__*/_jsx(TruncateString, {
      "data-test-id": "mediaTimeline-participantInitials",
      blockSize: "24px",
      tooltip: false,
      children: /*#__PURE__*/_jsx(Tooltip, {
        title: speakerName,
        children: /*#__PURE__*/_jsx("strong", {
          children: /*#__PURE__*/_jsx("small", {
            children: speakerInitials
          })
        })
      })
    }) : null;
  };
  const SpeakerTalkTimePercentage = speakerObject => {
    return typeof speakerObject.speaker.talkTimePercentage !== 'undefined' ? /*#__PURE__*/_jsx(TruncateString, {
      "data-test-id": "mediaTimeline-talkPercent",
      blockSize: "24px",
      children: /*#__PURE__*/_jsxs("small", {
        children: [speakerObject.speaker.talkTimePercentage, "%"]
      })
    }) : null;
  };
  return /*#__PURE__*/_jsx("span", {
    "data-test-id": "mediaTimeline-speakerList",
    children: speakerTimelineObjects.map((speakerTimelineObject, index) => {
      return /*#__PURE__*/_jsx(Timeline, {
        timelineName: `speaker-${index}`,
        leftColContent: SpeakerNameInitials(speakerTimelineObject),
        rightColContent: SpeakerTalkTimePercentage(speakerTimelineObject),
        pills: speakerTimelineObject.speakerPills
      }, `SpeakerLine-${index}`);
    })
  });
};
export default /*#__PURE__*/memo(MediaSpeakerTimeline);